import { useParams } from "react-router-dom";
import ExtendOffer from "./ExtendOffer";
import { Box } from "@mui/material";

export const ShowOffer = () => {
  const { id } = useParams();

  return (
    <Box className="pt-0 md:pt-12 ">
      <ExtendOffer row={{ id, onUpdate: () => {}, onDelete: () => {} }} />
    </Box>
  );
};
